<template lang="pug">
  v-dialog(
    v-model='popup'
    width="500"
    :color="color" 
    top 
  )
    v-card
      v-card-title
        | {{ text }}
      v-card-text(v-html="desc")
      v-card-actions
        v-btn( @click='popup = false' block text) OK
</template>

<script>
  export default {
    data: () => ({
      popup: false,
      text: '',
      desc: '',
      color: "yellow"
    }),
    created () {
      this.$bus.$on('popup-info', (info, desc) => {
        this.text = info
        this.desc = desc
        this.color = "red"
        this.popup = true
      })
    }
  }
</script>